import { truncate as _truncate } from 'lodash';

export function nrToWord(nr) {
  const words = [
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten'
  ];
  return words[nr];
}

export function smartTruncate(str, length = 15) {
  const words = String(str).split(/\s+/);
  for (let i = 0; i < words.length; i++) {
    if (words[i].length > length) {
      words[i] = truncate(words[i], length);
    }
  }
  return words.join(' ');
}

export function middleTruncate(str, length = 12, separator = '...') {
  if (str.length > length) {
    const splitSize = (length - separator.length) / 2;
    return (
      str.substr(0, Math.ceil(splitSize)) +
      separator +
      str.substr(str.length - Math.floor(splitSize))
    );
  }
  return str;
}

export function truncate(str, length = 10) {
  return _truncate(str, { length });
}
